import React from "react";
// import LawyerImage from "../assets/img/lawyer_banner.png";
import heroImage from "./img/heroImage.png";
import About from "./About";
const Primary = () => {
  return (
    <div style={{ marginBottom: "100px" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <img src={heroImage} style={{ width: "100%" }} alt="heroImage" />
          </div>
        </div>
      </div>
      <About />
    </div>
  );
};

export default Primary;
